import { stringify } from 'qs'
import assert from './assert'

export const functionsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/functions/catalog`
}

export const functionsCreatePath = args => {
  assert(args, 'workspaceSlug')

  const path = `/${args.workspaceSlug}/functions/catalog/new`

  if (args.query) {
    assert(args.query, ['type'])
    return `${path}?${stringify(args.query)}`
  }

  return path
}

export const functionPath = args => {
  assert(args, ['workspaceSlug', 'functionId'])
  return `/${args.workspaceSlug}/functions/catalog/${args.functionId}`
}

export const functionEditCodePath = args => {
  assert(args, ['workspaceSlug', 'functionId'])
  return `/${args.workspaceSlug}/functions/catalog/${args.functionId}/edit/code`
}

export const functionEditSettingsPath = args => {
  assert(args, ['workspaceSlug', 'functionId'])
  return `/${args.workspaceSlug}/functions/catalog/${args.functionId}/edit/settings`
}
